import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";

export class Errors {

    public static showGenericError(translate: TranslateService, showIfAlreadyVisible = true) {
        if (showIfAlreadyVisible || !Swal.isVisible()){
            Swal.fire({
                title: translate.instant('ERRORS.GENERIC.Title'),
                html: translate.instant('ERRORS.GENERIC.Text'),
                icon: 'error',
                confirmButtonText: translate.instant('Accept'),
                customClass: {
                    title: 'long-title'
                }
              });
        }
    }

    public static showUpdateAppRequired(translate: TranslateService): Promise<any> {
        return Swal.fire({
            title: translate.instant('ERRORS.UpdateRequired.Title'),
            html: translate.instant('ERRORS.UpdateRequired.Text'),
            icon: 'warning',
            confirmButtonText: translate.instant('Accept'),
            customClass: {
                title: 'long-title'
            }
          });
    }

}
